<template>
  <div class="form_config_con">
    <el-form ref="formConf" :model="formConf" label-width="100px" size="small">
      <el-form-item label="表单名称" required>
        <el-input
          size="small"
          class="input"
          v-model="formConf.formName"
        ></el-input>
      </el-form-item>
      <el-form-item label="英文名">
        <el-input
          size="small"
          class="input"
          v-model="formConf.enName"
        ></el-input>
      </el-form-item>
      <el-form-item label="表单分类" required>
        <el-select v-model="formConf.typeId" placeholder="请选择" size="small">
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.typeName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="表单名">
        <el-input
          disabled
          size="small"
          class="input"
          v-model="formConf.formRef"
        ></el-input>
      </el-form-item>
      <el-form-item label="表单模型">
        <el-input
          disabled
          size="small"
          class="input"
          v-model="formConf.formModel"
        ></el-input>
      </el-form-item>
      <el-form-item label="校验模型">
        <el-input
          disabled
          size="small"
          class="input"
          v-model="formConf.formRules"
        ></el-input>
      </el-form-item> -->

      <el-form-item label="表单尺寸">
        <el-radio-group v-model="formConf.size">
          <el-radio label="medium">中等</el-radio>
          <el-radio label="small">较小</el-radio>
          <el-radio label="mini">迷你</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="标签对齐">
        <el-radio-group v-model="formConf.labelPosition">
          <el-radio label="right">右对齐</el-radio>
          <el-radio label="left">左对齐</el-radio>
          <el-radio label="top">顶部对齐</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="标签宽度">
        <el-input-number
          v-model="formConf.labelWidth"
          :min="60"
          :max="180"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="栅格间隔">
        <el-input-number
          v-model="formConf.gutter"
          :min="0"
          :max="30"
          size="small"
        ></el-input-number>
      </el-form-item> -->
      <el-form-item label="动态表格支持组件高亮显示" class="multi_label">
        <el-switch v-model="formConfig.dynamicTableAllowed"></el-switch>
      </el-form-item>
      <el-form-item label="禁用表单">
        <el-switch v-model="formConf.disabled"></el-switch>
      </el-form-item>
      <el-form-item label="是否同步到大数据平台" class="multi_label">
        <el-switch
          v-model="formConfig.isPushData"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from "@api";
export default {
  name: "form_config",
  props: {
    formConf: {
      type: Object,
    },
    formConfig: {
      type: Object,
    },
  },
  data() {
    return {
      typeList: [],
    };
  },
  mounted() {
    this.loadTypeList();
  },
  methods: {
    loadTypeList() {
      this.$successAjax(api.formTypes, {}, { method: "get" }).then(
        ({ data }) => {
          // console.log(data);
          this.typeList = data;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>